import { render } from "./ThRules.vue?vue&type=template&id=79008b5a&scoped=true"
import script from "./ThRules.vue?vue&type=script&scoped=true&lang=js"
export * from "./ThRules.vue?vue&type=script&scoped=true&lang=js"

import "./ThRules.vue?vue&type=style&index=0&id=79008b5a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-79008b5a"

export default script